import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadProject: IProjectLoadActionCreator = () => {
        return {
            type: ACTION_PROJECTS_LOAD
        }
    },
    LoadProjectById: IProjectLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_PROJECTS_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IProjectLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_PROJECTS_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IProjectLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTS_LOAD_FAILURE,
            responseStatus
        }
    },
    SaveProject: IProjectSaveActionCreator = (formData) => {
        return {
            type: ACTION_PROJECTS_SAVE,
            formData
        }
    },
    SaveSuccess: IProjectSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_PROJECTS_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IProjectSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTS_SAVE_FAILURE,
            responseStatus
        }
    },
    CreateProject: IProjectCreateActionCreator = () => {
        return {
            type: ACTION_PROJECTS_CREATE
        }
    },
    CreateSuccess: IProjectCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_PROJECTS_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IProjectCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTS_CREATE_FAILURE,
            responseStatus
        }
    },
    ValidateProject: IProjectValidateActionCreator = (formData) => {
        return {
            type: ACTION_PROJECTS_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IProjectValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_PROJECTS_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IProjectValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTS_VALIDATE_FAILURE,
            responseStatus
        }
    },
    Clear: IProjectClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_PROJECTS_CLEAR,
            propertiesToClear
        }
    },
    Filter: IProjectFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_PROJECTS_FILTER,
            formFilter
        }
    };



export const
    ACTION_PROJECTS_LOAD = "ACTION_PROJECTS_LOAD",
    ACTION_PROJECTS_LOAD_BY_ID = "ACTION_PROJECTS_LOAD_BY_ID",
    ACTION_PROJECTS_LOAD_SUCCESS = "ACTION_PROJECTS_LOAD_SUCCESS",
    ACTION_PROJECTS_LOAD_FAILURE = "ACTION_PROJECTS_LOAD_FAILURE",

    ACTION_PROJECTS_SAVE = "ACTION_PROJECTS_SAVE",
    ACTION_PROJECTS_SAVE_SUCCESS = "ACTION_PROJECTS_SAVE_SUCCESS",
    ACTION_PROJECTS_SAVE_FAILURE = "ACTION_PROJECTS_SAVE_FAILURE",

    ACTION_PROJECTS_CREATE = "ACTION_PROJECTS_CREATE",
    ACTION_PROJECTS_CREATE_SUCCESS = "ACTION_PROJECTS_CREATE_SUCCESS",
    ACTION_PROJECTS_CREATE_FAILURE = "ACTION_PROJECTS_CREATE_FAILURE",

    ACTION_PROJECTS_VALIDATE = "ACTION_PROJECTS_VALIDATE",
    ACTION_PROJECTS_VALIDATE_SUCCESS = "ACTION_PROJECTS_VALIDATE_SUCCESS",
    ACTION_PROJECTS_VALIDATE_FAILURE = "ACTION_PROJECTS_VALIDATE_FAILURE",

    ACTION_PROJECTS_CLEAR = "ACTION_PROJECTS_CLEAR",

    ACTION_PROJECTS_FILTER = "ACTION_PROJECTS_FILTER";

export interface IProjectLoadAction {
    type: "ACTION_PROJECTS_LOAD";
}

export interface IProjectLoadActionCreator {
    (): IProjectLoadAction;
}

export interface IProjectLoadSuccessAction {
    type: "ACTION_PROJECTS_LOAD_SUCCESS";
    formData: Dtos.Project | Dtos.Project[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectLoadSuccessActionCreator {
    (
        formData: Dtos.Project | Dtos.Project[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IProjectLoadSuccessAction;
}

export interface IProjectLoadFailureAction {
    type: "ACTION_PROJECTS_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectLoadFailureAction;
}

export interface IProjectLoadByIdAction {
    type: "ACTION_PROJECTS_LOAD_BY_ID";
    id: number;
}

export interface IProjectLoadByIdActionCreator {
    (id: number): IProjectLoadByIdAction;
}



export interface IProjectSaveAction {
    type: "ACTION_PROJECTS_SAVE";
    formData: Dtos.Project;

}

export interface IProjectSaveActionCreator {
    (
        formData: Dtos.Project
    ): IProjectSaveAction;
}

export interface IProjectSaveSuccessAction {
    type: "ACTION_PROJECTS_SAVE_SUCCESS";
    formData: Dtos.Project;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectSaveSuccessActionCreator {
    (
        formData: Dtos.Project,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IProjectSaveSuccessAction;
}

export interface IProjectSaveFailureAction {
    type: "ACTION_PROJECTS_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IProjectSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectSaveFailureAction;
}

export interface IProjectCreateAction {
    type: "ACTION_PROJECTS_CREATE"
}

export interface IProjectCreateActionCreator {
    (): IProjectCreateAction
}

export interface IProjectCreateSuccessAction {
    type: "ACTION_PROJECTS_CREATE_SUCCESS";
    formData: Dtos.Project;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface IProjectCreateSuccessActionCreator {
    (
        formData: Dtos.Project,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IProjectCreateSuccessAction;
}

export interface IProjectCreateFailureAction {
    type: "ACTION_PROJECTS_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IProjectCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectCreateFailureAction;
}

export interface IProjectValidateAction {
    type: "ACTION_PROJECTS_VALIDATE";
    formData: Dtos.Project;

}

export interface IProjectValidateActionCreator {
    (
        formData: Dtos.Project
    ): IProjectValidateAction;
}

export interface IProjectValidateSuccessAction {
    type: "ACTION_PROJECTS_VALIDATE_SUCCESS";
    formData: Dtos.Project;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectValidateSuccessActionCreator {
    (
        formData: Dtos.Project,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IProjectValidateSuccessAction;
}

export interface IProjectValidateFailureAction {
    type: "ACTION_PROJECTS_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IProjectValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectValidateFailureAction;
}

export interface IProjectClearAction {
    type: "ACTION_PROJECTS_CLEAR";
    propertiesToClear?: string[];
}

export interface IProjectClearActionCreator {
    (propertiesToClear?: string[]): IProjectClearAction;
}

export interface IProjectFilterActionCreator {
    (formFilter: IFormFilter): IProjectFilterAction;
}

export interface IProjectFilterAction {
    type: "ACTION_PROJECTS_FILTER";
    formFilter: IFormFilter;
}

export type ProjectAction =
    IProjectLoadAction |
    IProjectLoadByIdAction |
    IProjectLoadFailureAction |
    IProjectLoadSuccessAction |
    IProjectSaveAction |
    IProjectSaveSuccessAction |
    IProjectSaveFailureAction |
    IProjectCreateAction |
    IProjectCreateSuccessAction |
    IProjectCreateFailureAction |
    IProjectValidateAction |
    IProjectValidateSuccessAction |
    IProjectValidateFailureAction |
    IProjectClearAction |
    IProjectFilterAction;
